import { DateTime } from "luxon";

/**
 * @property {string|null} id
 * @property {string|null} content
 * @property {DateTime|null} date
 * @property {boolean} isViewed
 */
export default class Notification {
    constructor(){
        this.id = null;
        this.content = null;
        this.date = null;
        this.isViewed = false;
    }

    /**
     * Returns a new `Notification` instance hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Notification}
     */
    static fromAPI(api_resource) {
        return Object.assign(new Notification(), {
            id: api_resource.id,
            content: api_resource.content,
            date: api_resource.date !== null ? DateTime.fromFormat(api_resource.date, "yyyy-MM-dd hh:mm:ss") : null,
            isViewed: api_resource.isViewed
        });
    }
    /**
     * @return {boolean}
     */
    isEchonews(){
        const regexp = new RegExp(/echonews/i);
        return regexp.test(this.content);
    }
}
